<template>
  <div v-if="isOnlineAndConfigured" class="device-hardware">
    <div v-if="!configurationEmpty" class="device-hardware__hardware-equipment">
      <CromiteOperation
        :configuration="configuration"
        :state="state"
        :ws="socket"
        :device="device"
        class="device-hardware__card-hardware"
      />
      <Phase
        :configuration="configuration"
        :isCromite="device && device.model === 'cmt'"
        :method="device.method"
        :state="state"
        :ws="socket"
        class="device-hardware__card-hardware"
      />
      <Pump
        :configuration="configuration"
        :state="state"
        :ws="socket"
        class="device-hardware__card-hardware"
        data-test-id="card-device-pump"
      />
      <Autosampler
        :configuration="configuration"
        :state="state"
        :ws="socket"
        :device="device"
        class="device-hardware__card-hardware"
        data-test-id="card-device-autosampler"
      />
      <ValveLoop
        :configuration="configuration"
        :state="state"
        :ws="socket"
        :device="device"
        class="device-hardware__card-hardware"
      />
      <Valve
        :configuration="configuration"
        :method="method"
        :state="state"
        :ws="socket"
        class="device-hardware__card-hardware"
      />
      <AnalogDetector
        :configuration="configuration"
        :method="method"
        :state="state"
        class="device-hardware__card-hardware"
      />
      <Detector
        :configuration="configuration"
        :state="state"
        :ws="socket"
        class="device-hardware__card-hardware"
      />
    </div>
    <NotAvailableComponent v-else> No connected equipment</NotAvailableComponent>
  </div>
  <NotAvailableComponent v-else-if="device.is_online !== true" class="mt-8">
    Device is Offline
  </NotAvailableComponent>
  <NotAvailableComponent v-else class="mt-8"> Device not configured</NotAvailableComponent>
</template>

<script>
  import NotAvailableComponent from 'components/element/NotAvailableComponent';
  import Pump from 'components/block/hardware/Pump';
  import Autosampler from 'components/block/hardware/Autosampler';
  import ValveLoop from 'components/block/hardware/ValveLoop';
  import AnalogDetector from 'components/block/hardware/AnalogDetector';
  import Detector from 'components/block/hardware/Detector';
  import Phase from 'components/block/hardware/liquids/Phase';
  import CromiteOperation from '@/components/block/hardware/CromiteOperation.vue';
  import Valve from '@/components/block/hardware/Valve.vue';

  export default {
    name: 'DeviceHardwareComponent',

    components: {
      Valve,
      CromiteOperation,
      Phase,
      Detector,
      AnalogDetector,
      ValveLoop,
      Autosampler,
      Pump,
      NotAvailableComponent,
    },

    props: {
      device: Object,
      method: Object,
      socket: Object, //DeviceSocket
      deviceState: {
        type: Object,
      },
    },

    computed: {
      configuration() {
        return this.device?.configuration;
      },
      state() {
        return this.deviceState;
      },

      isOnlineAndConfigured() {
        return this.device?.is_online === true && this.configuration && this.state?.ready != null;
      },

      configurationEmpty() {
        return (
          this.configuration == null ||
          (this.configuration.pump == null &&
            this.configuration.autosampler == null &&
            this.configuration.valve == null &&
            this.configuration.valve_loop == null &&
            this.configuration.detector == null &&
            this.configuration.analog_signal == null)
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  .device-hardware {
    overflow-x: hidden;

    &__hardware-equipment {
      display: flex;
      flex-wrap: wrap;
      margin-right: -2px;
    }

    &__card-hardware {
      max-width: 100%;
      margin-right: 2px;
      margin-bottom: 2px;
      flex: 1 1 auto;
      width: calc(25% - 2px);

      @media (max-width: $screen-sm-max) {
        width: calc(33.3% - 2px);
      }

      @media (max-width: $screen-xs-max) {
        width: calc(50% - 2px);
      }
    }
  }
</style>
